export class FilterLogicGroupError {
  constructor(message) {
    this.message = message;
  }
}